import { Backdrop, BoxProps, LinearProgress, styled } from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";
import HelpiaLogo from "/helpia-logo.svg?url";
import Typography from "@mui/material/Typography";

const ImageContainer = styled(Box)<BoxProps>(({ theme }) => ({
  "&.MuiBox-root": {
    background: theme.palette.secondary.dark,
    height: "64px",
    color: "#fff",
    borderRadius: "10px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    //alignItems: "center"
  },
}));

const StyledImage = styled("img")(() => ({
  width: "150px",
}));

const ModuleFallBack: React.FC = () => {
  return (
    <Backdrop sx={{ zIndex: 999 }} open={true}>
      <Box sx={{ textAlign: "center" }}>
        <ImageContainer sx={{ mb: 2 }}>
          <StyledImage src={HelpiaLogo} alt="Helpia People" className="h-7" />
          <Box>
            <Typography variant="caption">BackOffice</Typography>
          </Box>
        </ImageContainer>

        <LinearProgress
          sx={{
            height: "8px",
            width: "100%",
            borderRadius: "8px",
          }}
          variant="indeterminate"
          color="secondary"
        />
      </Box>
    </Backdrop>
  );
};

export default ModuleFallBack;
